/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCampaignFromJSON, ApiCampaignToJSON, } from './ApiCampaign';
import { ApiClassificationItemFromJSON, ApiClassificationItemToJSON, } from './ApiClassificationItem';
import { ApiExternalClickFromJSON, ApiExternalClickToJSON, } from './ApiExternalClick';
import { ApiExternalEntityStatusFromJSON, ApiExternalEntityStatusToJSON, } from './ApiExternalEntityStatus';
import { ApiLandingPathFromJSON, ApiLandingPathToJSON, } from './ApiLandingPath';
import { ApiServiceFromJSON, ApiServiceToJSON, } from './ApiService';
import { ApiSyncFromJSON, ApiSyncToJSON, } from './ApiSync';
export function ApiExternalCampaignFromJSON(json) {
    return ApiExternalCampaignFromJSONTyped(json, false);
}
export function ApiExternalCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'classificationItems': !exists(json, 'classificationItems') ? undefined : (json['classificationItems'].map(ApiClassificationItemFromJSON)),
        'clicks': !exists(json, 'clicks') ? undefined : (json['clicks'].map(ApiExternalClickFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'entityStatus': !exists(json, 'entityStatus') ? undefined : ApiExternalEntityStatusFromJSON(json['entityStatus']),
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'landingPath': !exists(json, 'landingPath') ? undefined : ApiLandingPathFromJSON(json['landingPath']),
        'landingPathId': !exists(json, 'landingPathId') ? undefined : json['landingPathId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'service': !exists(json, 'service') ? undefined : ApiServiceFromJSON(json['service']),
        'smartLinkUrl': !exists(json, 'smartLinkUrl') ? undefined : json['smartLinkUrl'],
        'splitCampaign': !exists(json, 'splitCampaign') ? undefined : ApiCampaignFromJSON(json['splitCampaign']),
        'splitCampaignId': !exists(json, 'splitCampaignId') ? undefined : json['splitCampaignId'],
        'sync': !exists(json, 'sync') ? undefined : ApiSyncFromJSON(json['sync']),
        'syncId': !exists(json, 'syncId') ? undefined : json['syncId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiExternalCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'classificationItems': value.classificationItems === undefined ? undefined : (value.classificationItems.map(ApiClassificationItemToJSON)),
        'clicks': value.clicks === undefined ? undefined : (value.clicks.map(ApiExternalClickToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'entityStatus': ApiExternalEntityStatusToJSON(value.entityStatus),
        'externalId': value.externalId,
        'id': value.id,
        'landingPath': ApiLandingPathToJSON(value.landingPath),
        'landingPathId': value.landingPathId,
        'name': value.name,
        'service': ApiServiceToJSON(value.service),
        'smartLinkUrl': value.smartLinkUrl,
        'splitCampaign': ApiCampaignToJSON(value.splitCampaign),
        'splitCampaignId': value.splitCampaignId,
        'sync': ApiSyncToJSON(value.sync),
        'syncId': value.syncId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
